module.exports = __webpack_public_path__ + "img/gpre-btn.d4acccd2.png";